import type {RelativeDate, Val} from 'schemaDefinition/types';

export const isRelativeDateValue = (value: Val): value is RelativeDate =>
  typeof value === 'object' && (value as RelativeDate).$date !== undefined;
